import { DrawerListProps, DrawerOpenTypes, DrawerProps } from "./types";
import * as styles from "./styles";
import { useState } from "react";

export const Drawer = ({
  className,
  children,
  width = 350,
  position = "right",
  open,
  onClose,
}: DrawerListProps) => {
  const getAsideClass = () => {
    if (open === "open" || open === "opening") {
      return position === "right"
        ? "animate__fadeInRight"
        : "animate__fadeInLeft";
    } else if (open === "closing" || open === "close") {
      return position === "right"
        ? "animate__fadeOutRight"
        : "animate__fadeOutLeft";
    } else {
      return "";
    }
  };

  return (
    <>
      <aside
        className={`drawer animate__animated ${className} ${styles.sidebar({
          open,
          width,
          position,
        })} ${getAsideClass()}`}
      >
        {children({ onClose })}
      </aside>
      {open !== "close-full" && (
        <div onClick={onClose} className={`${styles.layer(open)}`} />
      )}
    </>
  );
};
